"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporaryPlaing = exports.TemporaryPaused = exports.Paused = exports.Playing = exports.NotApplicable = exports.PlaybackGroup = exports.UncontrolledPlaybackPolicy = void 0;
const tslib_1 = require("tslib");
const state_flow_1 = require("@video/state-flow");
const Host = tslib_1.__importStar(require("../manifest/host"));
const Manifest = tslib_1.__importStar(require("../manifest/manifest"));
const state_flow_2 = require("../state-flow");
//#region State Props
const ROLLBACK_DELAY = 50;
var UncontrolledPlaybackPolicy;
(function (UncontrolledPlaybackPolicy) {
    UncontrolledPlaybackPolicy[UncontrolledPlaybackPolicy["Ignore"] = 0] = "Ignore";
    UncontrolledPlaybackPolicy[UncontrolledPlaybackPolicy["Apply"] = 1] = "Apply";
    UncontrolledPlaybackPolicy[UncontrolledPlaybackPolicy["Reject"] = 2] = "Reject";
    UncontrolledPlaybackPolicy[UncontrolledPlaybackPolicy["RollbackWithDelay"] = 3] = "RollbackWithDelay";
})(UncontrolledPlaybackPolicy || (exports.UncontrolledPlaybackPolicy = UncontrolledPlaybackPolicy = {}));
//#endregion
//#region Group Declaration
exports.PlaybackGroup = state_flow_2.PlayerStateFlow.registerGroup("playback").bootstrap(() => {
    return (0, exports.NotApplicable)({ position: null, autoPlay: true, uncontrolledPlaybackPolicy: UncontrolledPlaybackPolicy.RollbackWithDelay, delay: 0 });
});
//#endregion
//#region Signals Handlers
function uncontrolledPlay(states, signal) {
    switch (states.playback.uncontrolledPlaybackPolicy) {
        case UncontrolledPlaybackPolicy.Apply:
            return play(states, signal);
        case UncontrolledPlaybackPolicy.Reject:
            return state_flow_1.Result.reject("uncontrolled play() calls are not allowed");
        case UncontrolledPlaybackPolicy.RollbackWithDelay:
            return (0, exports.TemporaryPlaing)({ ...states.playback, delay: ROLLBACK_DELAY });
    }
    return state_flow_1.Result.ignore("ignored by policy");
}
function uncontrolledPause(states, signal) {
    switch (states.playback.uncontrolledPlaybackPolicy) {
        case UncontrolledPlaybackPolicy.Apply:
            return pause(states, signal);
        case UncontrolledPlaybackPolicy.Reject:
            return state_flow_1.Result.reject("uncontrolled pause() calls are not allowed");
        case UncontrolledPlaybackPolicy.RollbackWithDelay:
            return (0, exports.TemporaryPaused)({ ...states.playback, delay: ROLLBACK_DELAY });
    }
    return state_flow_1.Result.ignore("ignored by policy");
}
function play(states, signal) {
    if (!Host.Attached.is(states.host)) {
        return state_flow_1.Result.reject("host is not attached");
    }
    if (!Manifest.Online.is(states.manifest)) {
        return state_flow_1.Result.reject("manifest must be online to playing media");
    }
    return (0, exports.Playing)(states.playback);
}
function pause(groups, signal) {
    if (!Host.Attached.is(groups.host)) {
        return state_flow_1.Result.reject("host is not attached");
    }
    if (!Manifest.Online.is(groups.manifest)) {
        return state_flow_1.Result.reject("manifest must be online to playing media");
    }
    return (0, exports.Paused)(groups.playback);
}
//#endregion
//#region States Declarations
exports.NotApplicable = exports.PlaybackGroup.registerState("NotApplicable", {
    hostElementAttach: (g, s) => (0, exports.Paused)(g.playback),
});
exports.Playing = exports.PlaybackGroup.registerState("Playing", {
    hostElementDetach: (g) => (0, exports.NotApplicable)(g.playback),
    requestPause: pause,
    internalPause: pause,
    uncontrolledPause,
});
exports.Paused = exports.PlaybackGroup.registerState("Paused", {
    hostElementDetach: (g) => (0, exports.NotApplicable)(g.playback),
    requestPlay: play,
    internalPlay: play,
    uncontrolledPlay,
});
exports.TemporaryPaused = exports.PlaybackGroup.registerState("ExternalPaused", {
    hostElementDetach: (g) => (0, exports.NotApplicable)(g.playback),
    uncontrolledPlay,
});
exports.TemporaryPlaing = exports.PlaybackGroup.registerState("ExternalPaused", {
    hostElementDetach: (g) => (0, exports.NotApplicable)(g.playback),
    uncontrolledPause,
});
// // VODs are not implemented yet
// export const Ended = PlaybackGroup.registerState("Ended", {
//   hostElementDetach: (g) => NotApplicable(g.playback),
// });
//#endregion
//# sourceMappingURL=playback.js.map